import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import UserApi from "../../api/UserApi";
import InfoIcon from "../../Icons/NotificationMessage/Info";
import { ENotificationType } from "../../Model/ENotificationType";
import { EUserRole, User } from "../../Model/User";
import { sendNotification } from "../../redux/actions/NotificationAction";
import { getUserCredential } from "../../redux/reducers/LocalUserReducer";
import { getNotifications } from "../../redux/reducers/NotificationReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import MtiButton from "../Buttons/MtiButton";
import RadioButton from "../Buttons/RadioButton";
import CommandPanel from "../CommandPanel/CommandPanel";
import "./ChangeRolePanel.css";

type Props = {
  user: User;
  style?: React.CSSProperties;
  onUserUpdated: () => void;
  backBtn: () => void;
};

export default function ChangeRolePanel({ user, style, backBtn, onUserUpdated }: Props) {
  const [userRole, setUserRole] = useState(user.userRole);
  const notifications = useTypedSelector((state) => getNotifications(state));
  const dispatch = useDispatch();
  const currentUser = useTypedSelector((state) => getUserCredential(state));

  const onClickChangeStatus = () => {
    let newUser = { ...user };
    newUser.userRole = userRole;
    UserApi.updateUser(newUser).then((result) => {
      if (notifications.length === 0) {
        dispatch(sendNotification(ENotificationType.Success, "Change Role Success"));
        onUserUpdated();
        backBtn();
      }
    });
  };

  useEffect(() => {
    setUserRole(user.userRole);
  }, [user]);

  return (
    <CommandPanel>
      <CommandPanel.UsersInfoHeader users={[user]} />
      <CommandPanel.BackArrowHeader title="Change Role" onBackArrowClick={backBtn} />
      <CommandPanel.VerticalContent>
        <div>
          <div className="status-radio-buttons">
            {currentUser?.role === EUserRole.Support && (
              <RadioButton
                id={EUserRole[2]}
                name="user-role-support"
                label={EUserRole[2]}
                checked={userRole === EUserRole.Support}
                onChange={() => setUserRole(EUserRole.Support)}
                style={{
                  flex: "1 1 33%",
                  marginTop: 10,
                }}
              />
            )}
            <RadioButton
              id={EUserRole[1]}
              name="user-role-admin"
              label={EUserRole[1]}
              checked={userRole === EUserRole.Administrator}
              onChange={() => setUserRole(EUserRole.Administrator)}
              style={{
                flex: "1 1 33%",
                marginTop: 10,
              }}
            />
            <RadioButton
              id={EUserRole[3]}
              name="user-role-regular"
              label={EUserRole[3]}
              checked={userRole === EUserRole.Regular}
              onChange={() => setUserRole(EUserRole.Regular)}
              style={{
                flex: "1 1 33%",
                marginTop: 10,
              }}
            />
          </div>
          {userRole !== user.userRole && (
            <>
              <div className="status-question">
                <p>Are you sure want to change this user's Role?</p>
              </div>
              <div className="panel-info">
                <div className="icon">
                  <InfoIcon fill="#956507" width={34} height={34} />
                </div>
                <div className="text">
                  {userRole === EUserRole.Administrator && (
                    <p>This role will make this user have full access in the software.</p>
                  )}
                  {userRole === EUserRole.Support && (
                    <p>This role will make this user have full access in the software.</p>
                  )}
                  {userRole === EUserRole.Regular && (
                    <p>This role will make this user have limited access in the software.</p>
                  )}
                </div>
              </div>
            </>
          )}
          <div className="status-buttons">
            <MtiButton size="large" onClick={backBtn} variant="secondary" style={{ marginRight: 10 }}>
              Cancel
            </MtiButton>
            <MtiButton size="large" onClick={onClickChangeStatus}>
              Yes
            </MtiButton>
          </div>
        </div>
      </CommandPanel.VerticalContent>
    </CommandPanel>
  );
}
